import * as constants from '../constants/executors';
import {pagination} from '../../config/settings';
import * as _ from 'lodash';

export const initialState = {
  item: null,
  list: [],
  totalCount: 0,
  loading: false,
  params: {
    ordering: 'id', limit: pagination.limit, offset: 0, search: null
  },
  pagesCount: 1,
  page: 1,
};

export default (state = _.cloneDeep(initialState), action) => {
  if (!action.second) {
    return state;
  }

  switch (action.type) {
    case constants.GET_EXECUTORS:
    case constants.GET_EXECUTOR:
    case constants.UPDATE_EXECUTOR:
    case constants.REMOVE_EXECUTOR:
      return {
        ...state,
        loading: true
      };

    case constants.GET_EXECUTORS_ERROR:
    case constants.GET_EXECUTOR_ERROR:
    case constants.UPDATE_EXECUTOR_ERROR:
    case constants.REMOVE_EXECUTOR_ERROR:
      return {
        ...state,
        clearing: false,
        loading: false,
      };

    case constants.GET_EXECUTORS_SUCCESS:
      return {
        ...state,
        loading: false,
        clearing: false,
        list: action.payload,
        item: null,
        totalCount: action.totalCount,
        pagesCount: Math.ceil(action.totalCount / pagination.limit)
      };

    case constants.GET_EXECUTOR_SUCCESS:
      return {
        ...state,
        loading: false,
        list: [],
        item: action.payload,
      };

    case constants.EDIT_EXECUTOR:
      return {
        ...state,
        item: action.data,
      };
    case constants.EXECUTORS_CHANGE_PARAMS:
      return {
        ...state,
        params: action.data,
      };
    case constants.EXECUTORS_UPDATE_PARAMS:
      return {
        ...state,
        params: action.data !== null ? _.merge(state.params, action.data) : _.cloneDeep(initialState.params)
      };
    case constants.EXECUTORS_RESET_PARAMS:
      return {
        ...state,
        clearing: false,
        params: _.cloneDeep(initialState.params)
      };
    case constants.EXECUTORS_CHANGE_PAGE:
      return {
        ...state,
        page: +action.data,
      };
    case constants.EXECUTORS_CLEAR:
      return {
        ...state,
        clearing: true,
        totalCount: 0,
        pagesCount: 1,
        page: 1,
        item: null,
        list: []
      };

    default:
      return state;
  }
};